import styled from "styled-components";
import { tokens } from "../../../../public/tokens";

export const StyledBulkVersion = styled.div({
    width: "143px",
    minWidth: "143px",
    flex: "0 0 143px",

    ul: {
        right: "auto !important",
        width: "230px !important",
        minWidth: "230px !important",
        maxWidth: "230px !important",
    },

    li: {
        whiteSpace: "nowrap",
    },
});

export const StyledProcessingButton = styled.button({
    height: "35px",
    padding: `0 ${tokens.globals["spacing-2-5"]}`,
    border: `1px solid ${tokens.colors.brand.blue["500"]}`,
    borderRadius: tokens.globals["border-radius"],
    background: tokens.colors.brand.blue["50"],
    color: tokens.colors.brand.blue["500"],
    boxShadow: `0 1px 1px ${tokens.colors.neutral.grey.Alpha["10"]}`,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.globals["spacing-1-5"],
    fontFamily: tokens.typography.fontFamilies["albert-sans"],
    fontSize: tokens.typography.fontSize["lg-14px"],
    fontWeight: tokens.typography.fontWeights.semibold,
    whiteSpace: "nowrap",
});

export const StyledDisabledBulkAction = styled.div(({ $disabled }) => ({
    display: "inline-flex",
    opacity: $disabled ? 0.5 : 1,
    pointerEvents: $disabled ? "none" : "auto",
}));

export const StyledBulkButton = styled.button(({ $iconTone = "default" }) => {
    const infoColor =
        tokens.colors.states.info?.default ||
        tokens.colors.brand["tide-blue"]?.["500"] ||
        tokens.colors.brand.blue["500"];

    const iconColors = {
        lock: tokens.colors.states.warning["500"],
        unlock: infoColor,
        default: tokens.colors.text.primary,
    };

    return {
        height: "35px",
        padding: `0 ${tokens.globals["spacing-2-5"]}`,
        border: `1px solid ${tokens.colors.surfaces["border-divider"]}`,
        borderRadius: tokens.globals["border-radius"],
        background: tokens.colors.surfaces["container-background"],
        color: tokens.colors.text.primary,
        boxShadow: tokens.effects.effects.shadow.default,
        fontFamily: tokens.typography.fontFamilies["albert-sans"],
        fontSize: tokens.typography.fontSize["lg-14px"],
        fontWeight: tokens.typography.fontWeights.semibold,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: tokens.globals["spacing-1-5"],
        cursor: "pointer",
        whiteSpace: "nowrap",

        i: {
            color: iconColors[$iconTone] || iconColors.default,
            fontSize: tokens.typography.fontSize["lg-14px"],
            lineHeight: tokens.typography.fontSize["lg-14px"],
        },

        "&:hover:not(:disabled)": {
            background: tokens.colors.neutral.grey["900"],
            borderColor: tokens.colors.neutral.grey["900"],
            color: tokens.colors.neutral.white,
        },

        "&:focus-visible": {
            outline: `1px solid ${tokens.colors.brand.blue["500"]}`,
            outlineOffset: "2px",
        },

        "&:disabled": {
            opacity: 0.5,
            cursor: "not-allowed",
        },
    };
});

